import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { ErrorResponse, ServerError } from './ErrorResponse';
export var CreateRelationshipError = /*#__PURE__*/ function(CreateRelationshipError) {
    CreateRelationshipError["MissingContact"] = "missingContact";
    CreateRelationshipError["MissingServices"] = "missingServices";
    CreateRelationshipError["OptionalServices"] = "optionalServices";
    CreateRelationshipError["MultipleRecipients"] = "multipleRecipients";
    CreateRelationshipError["MissingDetails"] = "missingDetails";
    CreateRelationshipError["Member"] = "member";
    CreateRelationshipError["Phone"] = "phone";
    CreateRelationshipError["Name"] = "name";
    CreateRelationshipError["ReviewerSimilarToSeller"] = "reviewerSimilarToSeller";
    CreateRelationshipError["DuplicateReviewerEmail"] = "duplicateReviewerEmail";
    CreateRelationshipError["DuplicateNativeContact"] = "duplicateNativeContact";
    CreateRelationshipError["PackagesForExternallySign"] = "packagesForExternallySign";
    CreateRelationshipError["PackageNameTooLong"] = "packageNameTooLong";
    CreateRelationshipError["ServiceNameTooLong"] = "serviceNameTooLong";
    CreateRelationshipError["Unknown"] = "unknown";
    CreateRelationshipError["DraftIsDeleted"] = "draftIsDeleted";
    CreateRelationshipError["DraftLinkedToSentProposal"] = "draftLinkedToSentProposal";
    CreateRelationshipError["ExplicitApprovalNotAllowedForExternalSign"] = "explicitApprovalNotAllowedForExternalSign";
    CreateRelationshipError["ServiceEffectiveDateTooFarInPast"] = "serviceEffectiveDateTooFarInPast";
    CreateRelationshipError["UnresolvedTemplateVariables"] = "unresolvedTemplateVariables";
    CreateRelationshipError["ServiceDateBeforeEffectiveDate"] = "serviceDateBeforeEffectiveDate";
    CreateRelationshipError["ServiceStartBillingBeforeEffectiveDate"] = "serviceStartBillingBeforeEffectiveDate";
    CreateRelationshipError["CounterSignatureMissing"] = "counterSignatureMissing";
    CreateRelationshipError["CustomerAddressRequired"] = "customerAddressRequired";
    CreateRelationshipError["SignatureSetupIncomplete"] = "signatureSetupIncomplete";
    CreateRelationshipError["SignatureSignerMissingEmail"] = "signatureSignerMissingEmail";
    CreateRelationshipError["SignatureSubmissionRejected"] = "signatureSubmissionRejected";
    CreateRelationshipError["SignatureSignersLocked"] = "signatureSignersLocked";
    CreateRelationshipError["SignatureNotAllowed"] = "signatureNotAllowed";
    CreateRelationshipError["SignatureNotAllowedForExternalSign"] = "signatureNotAllowedForExternalSign";
    CreateRelationshipError["DocusealUnavailable"] = "docusealUnavailable";
    return CreateRelationshipError;
}({});
export class RelationshipErrorResponse {
    message(texts) {
        let legalTermsDocuments = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        const documentName = this.refusedDocumentName(legalTermsDocuments);
        return this.textsByErrorType(texts, documentName)[this.type]();
    }
    republishRefusalMessage(texts) {
        let legalTermsDocuments = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        var _this_error_serverErrorMessage;
        return (_this_error_serverErrorMessage = this.error.serverErrorMessage()) !== null && _this_error_serverErrorMessage !== void 0 ? _this_error_serverErrorMessage : this.type === "unknown" ? null : this.message(texts, legalTermsDocuments);
    }
    approveMessage(texts) {
        if (this.error.hasServerError(ServerError.MismatchingRelationshipVersion)) {
            return texts.relationship.mismatchingVersion();
        }
        if (this.error.hasServerError(ServerError.InvalidRelationshipStatus)) {
            return texts.proposal.canceled();
        }
        if (this.error.hasServerError(ServerError.FundingSourceNotFound)) {
            return texts.paymentMethod.updated();
        }
        return null;
    }
    isSignatureRefusal() {
        return this.signatureRefusals.has(this.type);
    }
    isKnown() {
        return this.type !== "unknown";
    }
    errorType() {
        const validationErrorCode = this.error.validationErrorCode();
        if (validationErrorCode) {
            return this.errorTypeFromValidationCode(validationErrorCode);
        } else if (this.error.hasServerError(ServerError.BuyerUserAssociatedWithVendor)) {
            return "member";
        } else if (this.error.hasPhoneValidationError()) {
            return "phone";
        } else if (this.error.hasServerError(ServerError.NameAlreadyExists)) {
            return "name";
        } else if (this.error.hasServerError(ServerError.CounterSignatureMissing)) {
            return "counterSignatureMissing";
        } else if (this.error.hasServerError(ServerError.CustomerAddressRequired)) {
            return "customerAddressRequired";
        } else if (this.error.hasServerError([
            ServerError.ReviewerEmailIsSimilarToSellerEmail,
            ServerError.AdditionalRecipientUserAssociatedWithVendor
        ])) {
            return "reviewerSimilarToSeller";
        } else if (this.error.hasServerError(ServerError.CantCreateAgreementExternallyFromDraftWithServiceBundles)) {
            return "packagesForExternallySign";
        } else if (this.error.hasServerError(ServerError.DuplicateReviewerEmail)) {
            return "duplicateReviewerEmail";
        } else if (this.error.hasServerError(ServerError.DuplicateNativeClientContact)) {
            return "duplicateNativeContact";
        } else if (this.error.hasServerError(ServerError.DraftIsDeleted)) {
            return "draftIsDeleted";
        } else if (this.error.hasServerError(ServerError.DraftLinkedToRelationship)) {
            return "draftLinkedToSentProposal";
        } else if (this.error.hasServerError(ServerError.ExplicitApprovalNotAllowedForExternalSign)) {
            return "explicitApprovalNotAllowedForExternalSign";
        } else if (this.error.hasServerError(ServerError.ServiceEffectiveDateTooFarInPast)) {
            return "serviceEffectiveDateTooFarInPast";
        } else if (this.error.hasServerError(ServerError.UnresolvedTemplateVariables)) {
            return "unresolvedTemplateVariables";
        } else if (this.error.hasServerError(ServerError.StageScheduleOnDateBeforeEffectiveDate)) {
            return "serviceDateBeforeEffectiveDate";
        } else if (this.error.hasServerError(ServerError.ServiceBillingStartBeforeEffectiveDate)) {
            return "serviceStartBillingBeforeEffectiveDate";
        } else if (this.error.hasServerError(ServerError.SignatureDocumentSetupIncomplete)) {
            return "signatureSetupIncomplete";
        } else if (this.error.hasServerError(ServerError.SignatureSignerMissingEmail)) {
            return "signatureSignerMissingEmail";
        } else if (this.error.hasServerError(ServerError.SignatureSubmissionRejected)) {
            return "signatureSubmissionRejected";
        } else if (this.error.hasServerError(ServerError.SignatureSignersLocked)) {
            return "signatureSignersLocked";
        } else if (this.error.hasServerError(ServerError.SignatureDocumentNotAllowed)) {
            return "signatureNotAllowed";
        } else if (this.error.hasServerError(ServerError.SignatureDocumentNotAllowedForExternalSign)) {
            return "signatureNotAllowedForExternalSign";
        } else if (this.error.hasServerError(ServerError.DocusealUnavailable)) {
            return "docusealUnavailable";
        }
        return "unknown";
    }
    refusedDocumentName(legalTermsDocuments) {
        var _this_error_context, _legalTermsDocuments_find;
        const legalTermsId = (_this_error_context = this.error.context()) === null || _this_error_context === void 0 ? void 0 : _this_error_context.legalTermsId;
        const refusedLegalTermsId = typeof legalTermsId === 'string' ? legalTermsId : undefined;
        return (_legalTermsDocuments_find = legalTermsDocuments.find((document)=>(document === null || document === void 0 ? void 0 : document.legalTermsId) === refusedLegalTermsId)) === null || _legalTermsDocuments_find === void 0 ? void 0 : _legalTermsDocuments_find.displayName;
    }
    errorTypeFromValidationCode(validationErrorCode) {
        switch(validationErrorCode){
            case 'title-bundles.name':
                return "packageNameTooLong";
            case 'title-services.name':
                return "serviceNameTooLong";
            case 'required-clientcontactid':
                return "missingContact";
            case 'services_or_service_bundles-services':
            case 'required-services':
                return "missingServices";
            case 'not_optional-services':
                return "optionalServices";
            case 'empty-reviewers':
                return "multipleRecipients";
            default:
                return "missingDetails";
        }
    }
    textsByErrorType(texts, documentName) {
        const namedOrUnnamed = (named, unnamed)=>documentName ? named({
                documentName
            }) : unnamed();
        return {
            ["missingContact"]: ()=>texts.relationship.missingContact(),
            ["missingServices"]: ()=>texts.relationship.noServicesIncluded(),
            ["optionalServices"]: ()=>texts.relationship.optionalServicesNotAvailable(),
            ["multipleRecipients"]: ()=>texts.relationship.multipleRecipientsNotAllowed(),
            ["missingDetails"]: ()=>texts.relationship.missingDetails(),
            ["member"]: ()=>texts.relationship.sameBusinessContact(),
            ["phone"]: ()=>texts.relationship.invalidPhoneNumber(),
            ["name"]: ()=>texts.relationship.templateNameExists(),
            ["reviewerSimilarToSeller"]: ()=>texts.relationship.sameBusinessRecipient(),
            ["packagesForExternallySign"]: ()=>texts.relationship.packagesNotAvailable(),
            ["packageNameTooLong"]: ()=>texts.relationship.packageNameTooLong(),
            ["serviceNameTooLong"]: ()=>texts.relationship.serviceNameTooLong(),
            ["duplicateReviewerEmail"]: ()=>texts.relationship.duplicateRecipientEmail(),
            ["duplicateNativeContact"]: ()=>texts.relationship.duplicateNativeContact(),
            ["draftIsDeleted"]: ()=>texts.relationship.draftDeleted(),
            ["draftLinkedToSentProposal"]: ()=>texts.relationship.draftLinkedToSentProposal(),
            ["explicitApprovalNotAllowedForExternalSign"]: ()=>texts.relationship.explicitApprovalNotAllowed(),
            ["serviceEffectiveDateTooFarInPast"]: ()=>texts.relationship.serviceStartDateTooOld(),
            ["unresolvedTemplateVariables"]: ()=>texts.relationship.unrecognizedCustomFields(),
            ["serviceDateBeforeEffectiveDate"]: ()=>texts.relationship.serviceDateBeforeEffectiveDate(),
            ["serviceStartBillingBeforeEffectiveDate"]: ()=>texts.relationship.serviceStartBillingBeforeEffectiveDate(),
            ["counterSignatureMissing"]: ()=>texts.relationship.counterSignatureMissing(),
            ["customerAddressRequired"]: ()=>texts.relationship.customerAddressRequired(),
            ["signatureSetupIncomplete"]: ()=>namedOrUnnamed(texts.relationship.signatureSetupIncomplete, texts.relationship.signatureSetupIncompleteUnnamed),
            ["signatureSignerMissingEmail"]: ()=>namedOrUnnamed(texts.relationship.signatureSignerMissingEmail, texts.relationship.signatureSignerMissingEmailUnnamed),
            ["signatureSubmissionRejected"]: ()=>namedOrUnnamed(texts.relationship.signatureSubmissionRejected, texts.relationship.signatureSubmissionRejectedUnnamed),
            ["signatureSignersLocked"]: ()=>texts.relationship.signatureSignersLocked(),
            ["signatureNotAllowed"]: ()=>texts.relationship.signatureNotAllowed(),
            ["signatureNotAllowedForExternalSign"]: ()=>texts.relationship.signatureNotAllowedForExternalSign(),
            ["docusealUnavailable"]: ()=>texts.relationship.signatureProviderUnavailable(),
            ["unknown"]: ()=>texts.relationship.internalError()
        };
    }
    constructor(error){
        _define_property(this, "type", void 0);
        _define_property(this, "error", void 0);
        _define_property(this, "signatureRefusals", new Set([
            "signatureSetupIncomplete",
            "signatureSignerMissingEmail",
            "signatureSubmissionRejected",
            "signatureSignersLocked",
            "signatureNotAllowed",
            "signatureNotAllowedForExternalSign",
            "docusealUnavailable"
        ]));
        this.error = error instanceof ErrorResponse ? error : new ErrorResponse(error);
        this.type = this.errorType();
    }
}
